<div class="container-fluid p-md-8 p-4">
    <div class="row">
        <div class="col-12 col-lg-6 order-1 order-lg-0">
            @let b2bProgram = (data$ | async)?.b2bProgram;

            @if (b2bProgram.prgType === b2bProgramType.NumberOfTrips) {
                <b2b-program-number-of-trips-form
                    [lyView]="!(isEditUser$ | async)"
                    [b2bProgram]="b2bProgram"
                    [b2bProgramType]="b2bProgram.prgType"
                    [prgId]="prgId"
                    [partners]="partners$ | async"
                    [pending]="pending$ | async"
                    (submitForm)="editB2bProgram($event)" />
            } @else {
                <b2b-program-single-product-form
                    [lyView]="!(isEditUser$ | async)"
                    [b2bProgram]="b2bProgram"
                    [b2bProgramType]="b2bProgram.prgType"
                    [prgId]="prgId"
                    [unit]="units"
                    [type]="rateTypes"
                    [partners]="partners$ | async"
                    [pending]="pending$ | async"
                    (submitForm)="editB2bProgram($event)" />
            }
        </div>
        <div class="col-12 col-lg-5 offset-lg-1 order-0 order-lg-1">
            @let partnerInfo = partnerInfo$ | async;
            @if (partnerInfo) {
                <aside class="border rounded pt-1 px-4 pb-4 mb-5">
                    @if (partnerInfo.accountNum >= 0) {
                        <div class="mt-3">
                            <b>{{ 'users.partner-form.form.labels.accountNum' | translate }}</b>
                            <p>{{ partnerInfo.accountNum }}</p>
                        </div>
                    }
                    @if (partnerInfo.phone) {
                        <div class="mt-3">
                            <b>{{ 'global.forms.labels.mobilePhone' | translate }}</b>
                            <p>{{ partnerInfo.phone | displayPhone }}</p>
                        </div>
                    }
                    @if (partnerInfo.email) {
                        <div class="mt-3">
                            <b>{{ 'global.forms.labels.email' | translate }}</b>
                            <p>{{ partnerInfo.email }}</p>
                        </div>
                    }
                    @if (partnerInfo.address) {
                        <div class="mt-3">
                            <b>{{ 'global.labels.address' | translate }}</b>
                            <p>{{ partnerInfo.address }}</p>
                        </div>
                    }
                    @if (partnerInfo.regNo) {
                        <div class="mt-3">
                            <b>{{ 'global.labels.regNo' | translate }}</b>
                            <p>{{ partnerInfo.regNo }}</p>
                        </div>
                    }
                </aside>
            }
        </div>
    </div>
</div>
